const routes = [
  {
    path: "/",
    redirect: "/home",
  },
  {
    path: "/home",
    name: "home",
    meta: { title: "首页" },
    component: () => import("@/views/home/index.vue"),
  },
  {
    path: "/mediate",
    name: "mediate",
    meta: { title: "智慧调解" },
    component: () => import("@/views/wisdom-mediate/index.vue"),
  },
  {
    path: "/judge",
    name: "judge",
    meta: { title: "审判服务" },
    component: () => import("@/views/judge-service/index.vue"),
  },
  {
    path: "/digitization",
    name: "digitization",
    meta: { title: "数字化市域治理" },
    component: () => import("@/views/digitization-city-govern/index.vue"),
  },
  {
    path: "/ecology",
    name: "ecology",
    meta: { title: "生态与合作" },
    component: () => import("@/views/ecology-cooperation/index.vue"),
  },
  {
    path: "/apply",
    name: "apply",
    meta: { title: "申请试用" },
    component: () => import("@/views/apply/index.vue"),
  },
];

export default routes;
